import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SLIDERIMAGE01 from "../../../../assets/images/sliderImage01.jpg";
import SLIDERIMAGE02 from "../../../../assets/images/sliderImage02.jpg";
import SLIDERIMAGE03 from "../../../../assets/images/sliderImage03.jpg";
import SLIDERIMAGE04 from "../../../../assets/images/sliderImage04.jpg";

import {
  Description,
  MainContainer,
  Heading,
  Button,
} from "./styled.components";
import { useNavigate } from "react-router-dom";

const HomePageSlider = () => {
  const navigate = useNavigate();
  const images = [SLIDERIMAGE01, SLIDERIMAGE02, SLIDERIMAGE03, SLIDERIMAGE04];
  const settings = {
    customPaging: function (i) {
      return (
        <a>
          <img src={images[i]} alt="img" />
        </a>
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
  };

  return (
    <>
      <MainContainer>
        <Slider {...settings}>
          <div>
            <div className="titleContainer">
              <Heading>
                Make Your <span>Vision</span> Become a <span>Reality</span>
              </Heading>
              <Description>
                Haji Hamid Hussain and Sons (3H) contractors and engineers is a multi-discplinary design and
                construction company in Pakistan since 5 dacades. 3H is focused
                to deliver highest level of professionalism to ehnace the
                infrastructure of comminuty. There is much more who we are and
                what we do.
              </Description>
              <Button onClick={() => navigate("/projects")}>
                View Projects <span>&#8594;</span>
              </Button>
            </div>
            <img src={SLIDERIMAGE01} alt="img" />
          </div>
          <div>
            <div className="titleContainer">
              <Heading>
                We Are <span>Building</span> the <span>Future</span>
              </Heading>{" "}
              <Description>
                We are focused on serving our clients, empowering our
                subs-contractors by providing smart city control solution across
                Pakistan.
              </Description>
              <Button onClick={() => navigate("/projects")}>
                View Projects <span>&#8594;</span>
              </Button>
            </div>
            <img src={SLIDERIMAGE02} alt="img" />
          </div>
          <div>
            <div className="titleContainer">
              <Heading>
                Forging Tomorrow with <span>Advanced Machinery</span>
              </Heading>{" "}
              <Description>
                We are committed to provide and use state-of-the-art
                construction machinery as par with the customer satidfaction
              </Description>
              <Button onClick={() => navigate("/projects")}>
                View Projects <span>&#8594;</span>
              </Button>
            </div>
            <img src={SLIDERIMAGE03} alt="img" />
          </div>
          <div>
            <div className="titleContainer">
              <Heading>
                We <span>Shape</span> Our <span>Buildings</span>
              </Heading>{" "}
              <Description>
                HHH been the leader in the construction industry Since 5
                Decades. Our Role in The construction Industry Stand Onwards
                From the Great Valley's of Gilgit Baltistan to the Different
                Regions of Pakistan
              </Description>
              <Button onClick={() => navigate("/projects")}>
                View Projects <span>&#8594;</span>
              </Button>
            </div>
            <img src={SLIDERIMAGE04} alt="img" />
          </div>
        </Slider>
      </MainContainer>
    </>
  );
};

export default HomePageSlider;
